import type { ClinicalTaskStatus } from '@heidi/schema/ml-scribe';

type StatusTask = {
  id?: string | null;
  status?: ClinicalTaskStatus | null;
};

export const withClinicalTaskStatus = <T extends StatusTask>(
  task: T,
  taskId: string,
  status: ClinicalTaskStatus
): T => {
  if (task.id !== taskId || task.status === status) return task;
  return { ...task, status };
};
